import styles from "./screen-skeleton.module.css";

type Variant = "dashboard" | "form" | "table" | "configuration" | "tracking";

function Bar({ width = "100%", height }: { width?: string; height?: string }) {
  return <span className={styles.bar} style={{ width, height }} />;
}

function Rows({ count = 4 }: { count?: number }) {
  return <div className={styles.rows}>{Array.from({ length: count }, (_, index) =>
    <div className={styles.row} key={index}><Bar width="42%" /><Bar width="18%" /><Bar width="14%" /><Bar width="12%" /></div>
  )}</div>;
}

/** Content-shaped loading state. The app header and sidebar remain usable and unblurred. */
export default function ScreenSkeleton({ label, variant = "dashboard", compact = false }: {
  label: string;
  variant?: Variant;
  compact?: boolean;
}) {
  return <div className={`${styles.skeleton} ${compact ? styles.compact : ""}`} role="status" aria-label={label}>
    <div aria-hidden="true">
      {!compact && <>
        {variant === "form" ? <>
          <section className={styles.card}><div className={styles.identity}><Bar width="3.5rem" height="3.5rem" /><div><Bar width="13rem" height="1.4rem" /><Bar width="9rem" /></div><Bar width="7rem" height="2.5rem" /></div><div className={styles.chips}><Bar width="6rem" /><Bar width="7rem" /><Bar width="5rem" /></div></section>
          <div className={styles.metrics}>{[0, 1, 2].map(item => <section className={styles.card} key={item}><Bar width="46%" /><Bar width="25%" height="2rem" /><Bar width="65%" /></section>)}</div>
        </> : variant === "tracking" ? <>
          <section className={styles.card}><div className={styles.identity}><Bar width="18rem" height="1.8rem" /><Bar width="30%" /></div><div className={styles.metrics}>{[0, 1, 2, 3].map(item => <div key={item}><Bar width="55%" /><Bar width="75%" height="1.6rem" /></div>)}</div></section>
          <section className={styles.card}><div className={styles.chips}><Bar width="9rem" height="2.5rem" /><Bar width="8rem" height="2.5rem" /><Bar width="7rem" height="2.5rem" /></div><div className={styles.metrics}>{[0, 1, 2, 3].map(item => <div key={item}><Bar width="65%" /><Bar width="45%" height="2rem" /><Bar width="80%" /></div>)}</div></section>
        </> : <>
          <section className={styles.card}><div className={styles.toolbar}><Bar width="11rem" height="2.5rem" /><Bar width="20rem" height="2.5rem" /><Bar width="7rem" height="2.5rem" /></div></section>
          {variant === "dashboard" && <div className={styles.metrics}>{[0, 1, 2, 3].map(item => <section className={styles.card} key={item}><Bar width="55%" /><Bar width="35%" height="2rem" /><Bar width="72%" /></section>)}</div>}
        </>}
      </>}
      <div className={variant === "form" ? styles.split : variant === "dashboard" || variant === "tracking" ? styles.content : styles.full}>
        <section className={styles.card}><Bar width="36%" height="1.5rem" /><Bar width="58%" />{variant === "form" ? <Rows count={5} /> : <Rows count={compact ? 4 : 6} />}</section>
        {(variant === "dashboard" || variant === "form" || variant === "tracking") && <section className={styles.card}><Bar width="48%" height="1.5rem" /><Bar width="70%" /><Rows count={variant === "form" ? 3 : 5} /></section>}
      </div>
    </div>
  </div>;
}
